import React, { useState } from 'react';
import { ArrowDownTrayIcon } from '@heroicons/react/24/outline';
import ExportModal from './ExportModal';

export default function ExportButton({ config, data, companyData }) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <ArrowDownTrayIcon
        className="h-5 w-5 text-indigo-600 hover:text-indigo-400 cursor-pointer ease-linear transition duration-200"
        aria-hidden="true"
        title={`Export ${config?.entityName || ''}`}
        onClick={() => setOpen(true)}
      />
      <ExportModal
        open={open}
        onClose={() => setOpen(false)}
        config={config}
        data={data}
        companyData={companyData}
      />
    </>
  );
}
